module.exports = __webpack_public_path__ + "static/head-5c4c40c62855dfe7647718477f893956.png";